import * as type from "./type";

const initialState = {
  units: [],
  unitAreas: [],
  selectedUnit: "",
  selectedUnitForView: "",
  filterUnitAspect: "",
  filterUnitBedroom: [],
  filterUnitGrossRent: "",
  filterUnitCentre: "",
  filterUnitLevel: "",
  filterUnitArea: "",
  filterUnitPrecinct: "",
  filterUnitPrice: "",
  filterUnitLotSize: "",
  filterUnitRoomType: [],
  filterUnitAvailability: [],
  isShowFloorplan: false,
  isShowGallery: false,
  isShowUnitDetail: false,
  unitQuery: {},
  isShowFilter: false,
  isShowPrecinctDetail: false,
  isShowVirtualTour: false,
  isShowUnitList: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case type.GET_UNIT_LIST:
      return {
        ...state,
        units: action.data.data,
      };
    case type.GET_UNIT_AREA_LIST:
      return {
        ...state,
        unitAreas: action.data.data,
      };
    case type.SET_IS_SHOW_FLOORPLAN:
      return {
        ...state,
        isShowFloorplan: action.data,
      };
    case type.SET_IS_SHOW_GALLERY:
      return {
        ...state,
        isShowGallery: action.data,
      };
    case type.SET_IS_SHOW_UNIT_DETAIL:
      return {
        ...state,
        isShowUnitDetail: action.data,
      };
    case type.SET_SELECTED_UNIT:
      const temp = action?.data?.data === "" ? state.selectedUnitForView : action?.data?.data;
      return {
        ...state,
        selectedUnit: action?.data?.data,
        selectedUnitForView: temp,
      };
    case type.SET_UNIT_QUERY:
      return {
        ...state,
        unitQuery: action.data,
      };
    case type.SET_IS_SHOW_FILTER:
      return {
        ...state,
        isShowFilter: action.data,
      };
    case type.SET_IS_SHOW_PRECINCT_DETAIL:
      return {
        ...state,
        isShowPrecinctDetail: action.data,
      };
    case type.FILTER_UNIT_ASPECT:
      return {
        ...state,
        filterUnitAspect: action.data,
      };
    case type.FILTER_UNIT_PRICE:
      return {
        ...state,
        filterUnitPrice: action.data,
      };
    case type.FILTER_UNIT_LOT_SIZE:
      return {
        ...state,
        filterUnitLotSize: action.data,
      };
    case type.FILTER_UNIT_BEDROOM:
      return {
        ...state,
        filterUnitBedroom: action.data,
      };
    case type.FILTER_UNIT_ROOM_TYPE:
      return {
        ...state,
        filterUnitRoomType: action.data,
      };
    case type.FILTER_UNIT_AVAILABILITY:
      return {
        ...state,
        filterUnitAvailability: action.data,
      };
    case type.SET_IS_SHOW_VIRTUAL_TOUR:
      return {
        ...state,
        isShowVirtualTour: action.data,
      };
    case type.SET_IS_SHOW_UNIT_LIST:
      return {
        ...state,
        isShowUnitList: action.data,
      };
    default:
      return state;
  }
};
